<template>
  <!-- 任意门组件
    @author: 王汝鹏
    @date: 2019-11-25
   -->
  <div class="form-item_free"
       :style="{'padding-left': paddingLeft}">
    <div class="enpty-free" 
         v-if="formNode.children == 0">请从左侧拖拽或点击任意添加组件</div>
    <draggable v-model="formNode.children"
               :value="formNode.children"
               @input="(v) => formNode.children=v.filter(i=>i)"
               @add="(e) => handleAddFormItem(e, formNode.children)"
               class="form-grid_draggable"
               :options="{group:{name:'free_wrap', put:onPut},
                          handle:'.drag-bar', 
                          ghostClass:'free-draggable-status_ghost'}">
      <form-item-template v-for="(el) in formNode.children" 
                          :key="el.id" 
                          :formNode="el"
                          :formParent="formNode.children"
                          :class="el.type">
      </form-item-template>
    </draggable>
  </div>
</template>

<script>
/** 混入方法 ::: 
 *  @mixin mixFormItemTemplateChild 编辑组件项子级混入
 */
import { mixFormItemTemplateChild } from "@/mixins/form_item/mix_form_item_template_child.js";


export default {
  components: { Draggable: require('vuedraggable') },
  mixins: [ mixFormItemTemplateChild ],
  methods: {
    /** @name 自由拖拽面板不可以嵌套【自由面板、栅格组件】
     *  @param {Object} sortable1 来源sortable对象
     *  @param {Object} sortable2 放入sortable对象
     *  @param {Object} el 拖拽元素
     *  @param {Object} e 拖拽事件对象
     *  @return {Boolean} {true:可以放入，false:不允许放入}
     *  @author 王汝鹏
     *  @version 2019-11-26
     */
    onPut(sortable1, sortable2, el, e) {
      let elClassList = [...el.classList];
      switch(true) {
        case elClassList.includes("grid"): return false;
        default: return true;
      }
    },
    /** @name 添加表单项
     *  @description 设置新表单项为激活状态，通过新表单项索引找到元素更新为激活项
     *  @param {Object} e
     *  - {Number} newIndex 表单项拖拽进来的索引位置
     *  - {Element} item 拖拽的元素对象
     *  @param {Array} formList 激活表单项父级
     *  @author 王汝鹏
     *  @version 2019-09-22
     */ 
    handleAddFormItem({newIndex, item}, formList) {
      // 模块组件拖拽
      if (item.className.indexOf("domain-component-item") !== -1) { return; }
      // 设置激活项
      let formNode = formList[newIndex];
      this.formListManager().activeNode(formNode, formList);
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/form_item/FormItemFree.vue